module.exports = __webpack_public_path__ + "static/media/icon_pallet.7967e180.svg";